import axios from "api/axios";
import { toast } from "react-toastify";

export const createFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post('/api/file/upload', formData);
  return response.data;
}

export const getFiles = async () => {
  const response = await axios.get('/api/file');
  return response.data.files;
}

export const downloadFile = async (docId) => {
  try {
    const response = await axios.get('/api/file/' + docId);
    return response.data.file;
  } catch (error) {
    console.log(error.message);
    toast.error('Something went wrong');
  }
}

export const deleteFile = async (docId) => {
  const res = await axios.delete('/api/file/' + docId);
  return res.data;
}